<template> 
  <Dialog v-model:visible="visible" unstyled modal :closeOnEscape="false" :closable="false" 
  class="w-full md:w-3/4 lg:w-3/5 xl:w-2/4 m-2 bg-white rounded-lg overflow-hidden"
  :pt="{
    mask:{
        style: 'background-color: rgba(0,0,0, 0.4)'
    }
  }"
  >
    <template #header>
        <div class="w-full inline-flex justify-between items-center px-4 py-3 mb-3 border-b border-slate-200">
            <h1 class="text-xl font-semibold"><slot name="title"></slot></h1>
            <Button type="button" @click="closeModalResponse" icon="pi pi-times" plain text />
        </div>
    </template>
    <div class="px-2 pb-4">
        <slot name="content"></slot>
    </div>
  </Dialog>
</template>

<script setup> 
import { onMounted, ref, watch }  from "vue";
  import Dialog from "primevue/dialog";
  import Button from "primevue/button";

let visible = ref(false) 

  const props = defineProps({
    isvisible: {
        type: Boolean,
        required: true,
        default: false
    }
  });

watch(() => props.isvisible, (newValue) => {
    visible.value = newValue;
     if(!visible.value)
        closeModalResponse();
});

  const emit = defineEmits(['closeModal'])

  function closeModalResponse() {
      emit('closeModal', false)
  }

    onMounted(()=> {
        visible.value = props.isvisible;
    });
</script>